import script from "./shijuanduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./shijuanduotiao.vue?vue&type=script&setup=true&lang=js"

import "./shijuanduotiao.vue?vue&type=style&index=0&id=1c8357a7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8357a7"]])

export default __exports__